<template>
  <div>
    <div v-if="policyPost">
      <div class="px-4 py-2 flex flex-col">
        <div class="text-2xl font-bold font-serif">{{ policyPost.title }}</div>
        <div v-if="policyCategory" class="text-sm italic text-gray-400 mt-1">{{ policyCategory.name }}</div>
        <div class="flex flex-wrap text-sm">
          <div class="w-full py-2">
            <div v-html="policyPost.description" class="ProseMirror view"></div>
          </div>
        </div>
        <div class="mt-3">
          <div v-for="(l, i) in policyPost.file_links" :key="i" class="">
            <a class="text-lg" target="_blank" :href="l.link">
              <BaseIcon icon="file-pdf" class="text-red-600 mr-2" />
              <span class="link">{{ l.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PolicyPostView",
  title() {
    return this.$t("page_titles.policy");
  },
  data() {
    return {
      policyPostId: this.$route.params.id,
      policyPost: null,
      policyCategory: null,
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    async getPolicyPost() {
      try {
        let response = await this.axios.get(`${process.env.VUE_APP_SERVER_URL}/policy-post/${this.policyPostId}`);
        this.policyPost = response.data.policy_post;
        this.policyCategory = response.data.policy_category;
      } catch (error) {
        this.handleError(error);
      }
    },
  },

  created() {
    this.getPolicyPost();
    this.setPageTitle(this.$t("top_titles.policy"), "policy_post");
  },
  watch: {
    "$i18n.locale"() {
      document.title = this.$t("page_titles.policy");
      this.setPageTitle(this.$t("top_titles.policy"), "addonBuy");
    },
  },
};
</script>
